import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Category from "@/pages/category/page";
import Detail from "@/pages/detail/page";
import Search from "@/pages/search/page";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout><Home /></Layout>,
  },
  {
    path: "/category/:type",
    element: <Layout><Category /></Layout>,
  },
  {
    path: "/detail/:id",
    element: <Layout><Detail /></Layout>,
  },
  {
    path: "/search",
    element: <Layout><Search /></Layout>,
  },
  {
    path: "/news",
    element: <Layout><News /></Layout>,
  },
  {
    path: "/news/:id",
    element: <Layout><NewsDetail /></Layout>,
  },
  {
    path: "/about",
    element: <Layout><About /></Layout>,
  },
  {
    path: "*",
    element: <Layout><NotFound /></Layout>,
  },
];

export default routes;